import { render, staticRenderFns } from "./CreateAddendumButton.vue?vue&type=template&id=cfed9378&scoped=true&"
import script from "./CreateAddendumButton.vue?vue&type=script&lang=js&"
export * from "./CreateAddendumButton.vue?vue&type=script&lang=js&"
import style0 from "./CreateAddendumButton.vue?vue&type=style&index=0&id=cfed9378&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfed9378",
  null
  
)

export default component.exports